var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-5"},[_c('h1',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.title))]),_c('AdsComponent',{attrs:{"advertisements":_vm.advertisements}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }